
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TableModalForm extends Vue {
  @Prop({ default: false }) readonly loading!: boolean
}
